(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.feeder-report.event
  (:require [common.util :as cu]
            [frontend.controller.websocket.event :as ws]
            [frontend.ui.page.lp-report-editor.step-2-data-gathering.sub :as sub]
            [frontend.ui.page.lp-report-editor.sub :as editor-sub]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::text-save-ok
 (fn [{db :db} _]
   (js/console.log "SAVE OK")))

(rf/reg-event-fx
 ::text-save-failed
 (fn [{db :db} [_ fund-report-id resp]]
   (js/console.log "Text save failed " resp)))


(rf/reg-event-fx
 ::save-fund-report-text
 (fn [{db :db} [_ fund-report-id dynamic-path new-value complete-path complete-status]]
   (let [feeders (get-in db editor-sub/feeder-reports-path)
         feeder-rich-content-list (get-in db sub/feeder-rich-content-list-path)
         updated-feeders (->> feeders
                              (mapv (fn [feeder]
                                      (if (not= (:db/id feeder) fund-report-id)
                                        feeder
                                        (-> feeder
                                            (assoc-in (concat [:lp-report/editable-data] dynamic-path)
                                                      new-value)
                                            (assoc-in (concat [:lp-report/editable-data] complete-path)
                                                      complete-status))))))
         feeder-report-new-list (->> feeder-rich-content-list
                                     (mapv (fn [rich-content-map]
                                             (if (= (:rich-content-completed-path rich-content-map) complete-path)
                                               (assoc rich-content-map
                                                      :completed? (not (cu/blank-value? complete-status))
                                                      :rich-content-completed-at complete-status
                                                      :rich-content new-value)
                                               rich-content-map))))]
     {:db       (cond-> db
                  updated-feeders (assoc-in editor-sub/feeder-reports-path updated-feeders)
                  (and (seq feeder-rich-content-list)
                       (not= feeder-rich-content-list feeder-report-new-list))
                  (assoc-in sub/feeder-rich-content-list-path feeder-report-new-list))
      ::ws/send {:id         :lp-report/update-text
                 :body       {:report-id       fund-report-id
                              :value-path      dynamic-path
                              :new-value       new-value
                              :complete-path   complete-path
                              :complete-status complete-status}
                 :on-success [::text-save-ok fund-report-id]
                 :on-error   [::text-save-failed fund-report-id]}})))

(rf/reg-event-fx
 ::submitted-for-review-text-ok
 (fn [{db :db} [_ feeder-id]]
   {:db (assoc-in db
         editor-sub/feeder-reports-path
         (->> (get-in db editor-sub/feeder-reports-path)
              (mapv (fn [feeder-report]
                      (if (not= (:db/id feeder-report) feeder-id)
                        feeder-report
                        (assoc feeder-report
                               :lp-report/text-status
                               :lp-report.publishing-status/pending-approval))))))}))

(rf/reg-event-fx
 ::submit-for-review-text-failed
 (fn [{db :db} [_ fund-report-id resp]]
   (js/console.log "Feeder Submit for review failed " resp)))


(rf/reg-event-fx
 ::submit-for-review-text-confirm
 (fn [{db :db} [_ fund-report-id recipients message]]
   {::ws/send {:id         :lp-report/submit-for-review-text
               :body       {:report-id  fund-report-id
                            :recipients recipients
                            :message    message}
               :on-success [::submitted-for-review-text-ok fund-report-id]
               :on-error   [::submit-for-review-text-failed fund-report-id]}}))

(rf/reg-event-fx
 ::submit-for-review-text
 (fn [{db :db} [_ fund-report-id]]
   {:db (-> db
            (assoc-in [::sub/fund-text-submitted?] fund-report-id))}))

(rf/reg-event-fx
 ::submitted-for-review-data-ok
 (fn [{db :db} [_ feeder-id]]
   {:db (assoc-in db
         editor-sub/feeder-reports-path
         (->> (get-in db editor-sub/feeder-reports-path)
              (mapv (fn [feeder-report]
                      (if (not= (:db/id feeder-report) feeder-id)
                        feeder-report
                        (assoc feeder-report
                               :lp-report/data-status
                               :lp-report.publishing-status/pending-approval))))))}))

(rf/reg-event-fx
 ::submit-for-review-data-failed
 (fn [{db :db} [_ fund-report-id resp]]
   (js/console.log "Feeder Submit for review data failed " resp)))


(rf/reg-event-fx
 ::submit-for-review-data-confirm
 (fn [{db :db} [_ fund-report-id recipients message]]
   {::ws/send {:id         :lp-report/submit-for-review-data
               :body       {:report-id  fund-report-id
                            :recipients recipients
                            :message    message}
               :on-success [::submitted-for-review-data-ok fund-report-id]
               :on-error   [::submit-for-review-data-failed fund-report-id]}}))

(rf/reg-event-fx
 ::submit-for-review-data
 (fn [{db :db} [_ fund-report-id]]
   {:db (-> db
            (assoc-in [::sub/fund-data-submitted?] fund-report-id))}))
(rf/reg-event-fx
 ::approve-text-ok
 (fn [{db :db} [_ feeder-id]]
   {:db (assoc-in db
         editor-sub/feeder-reports-path
         (->> (get-in db editor-sub/feeder-reports-path)
              (mapv (fn [feeder-report]
                      (if (not= (:db/id feeder-report) feeder-id)
                        feeder-report
                        (assoc feeder-report
                               :lp-report/text-status
                               :lp-report.publishing-status/approved))))))}))

(rf/reg-event-fx
 ::approve-data-ok
 (fn [{db :db} [_ feeder-id]]
   {:db (assoc-in db
         editor-sub/feeder-reports-path
         (->> (get-in db editor-sub/feeder-reports-path)
              (mapv (fn [feeder-report]
                      (if (not= (:db/id feeder-report) feeder-id)
                        feeder-report
                        (assoc feeder-report
                               :lp-report/data-status
                               :lp-report.publishing-status/approved))))))}))

(rf/reg-event-fx
 ::approve-text-failed
 (fn [{db :db} [_ fund-report-id resp]]
   (js/console.log "Approve text failed " resp)))

(rf/reg-event-fx
 ::approve-data-failed
 (fn [{db :db} [_ fund-report-id resp]]
   (js/console.log "Approve data failed " resp)))

(rf/reg-event-fx
 ::approve-text
 (fn [{db :db} [_ fund-report-id]]
   {::ws/send {:id         :lp-report/approve-text
               :body       {:report-id fund-report-id}
               :on-success [::approve-text-ok fund-report-id]
               :on-error   [::approve-text-failed fund-report-id]}}))

(rf/reg-event-fx
 ::approve-data
 (fn [{db :db} [_ fund-report-id]]
   {::ws/send {:id         :lp-report/approve-data
               :body       {:report-id fund-report-id}
               :on-success [::approve-data-ok fund-report-id]
               :on-error   [::approve-data-failed fund-report-id]}}))

(rf/reg-event-fx
 ::reject-text-ok
 (fn [{db :db} [_ feeder-id]]
   {:db (assoc-in db
         editor-sub/feeder-reports-path
         (->> (get-in db editor-sub/feeder-reports-path)
              (mapv (fn [feeder-report]
                      (if (not= (:db/id feeder-report) feeder-id)
                        feeder-report
                        (assoc feeder-report
                               :lp-report/text-status
                               :lp-report.publishing-status/wip))))))}))

(rf/reg-event-fx
 ::reject-text-failed
 (fn [{db :db} [_ fund-report-id resp]]
   (js/console.log "Reject failed " resp)))

(rf/reg-event-fx
 ::on-reject-confirmed
 (fn [{db :db} [_ fund-report-id recipients message]]
   {::ws/send {:id         :lp-report/reject-text
               :body       {:report-id  fund-report-id
                            :recipients recipients
                            :message    message}
               :on-success [::reject-text-ok fund-report-id]
               :on-error   [::reject-text-failed fund-report-id]}}))

(rf/reg-event-fx
 ::reject-text
 (fn [{db :db} [_ fund-report-id]]
   {:db (-> db
            (assoc-in [::sub/fund-text-rejected?] fund-report-id))}))

;; data
(rf/reg-event-fx
 ::reject-data-ok
 (fn [{db :db} [_ feeder-id]]
   {:db (assoc-in db
         editor-sub/feeder-reports-path
         (->> (get-in db editor-sub/feeder-reports-path)
              (mapv (fn [feeder-report]
                      (if (not= (:db/id feeder-report) feeder-id)
                        feeder-report
                        (assoc feeder-report
                               :lp-report/data-status
                               :lp-report.publishing-status/wip))))))}))

(rf/reg-event-fx
 ::reject-data-failed
 (fn [{db :db} [_ fund-report-id resp]]
   (js/console.log "Reject failed " resp)))

(rf/reg-event-fx
 ::reject-data-confirm
 (fn [{db :db} [_ fund-report-id recipients message]]
   {::ws/send {:id         :lp-report/reject-data
               :body       {:report-id  fund-report-id
                            :recipients recipients
                            :message    message}
               :on-success [::reject-data-ok fund-report-id]
               :on-error   [::reject-data-failed fund-report-id]}}))

(rf/reg-event-fx
 ::reject-data
 (fn [{db :db} [_ fund-report-id]]
   {:db (-> db
            (assoc-in [::sub/fund-data-rejected?] fund-report-id))}))

(rf/reg-event-fx
 ::close-viewer
 (fn [{db :db} [_]]
   {:db (assoc-in db sub/gathering-mode-path :report-listing)}))
